import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  generateQuestionsApiService,
  type GenerateQuestionsRequest,
  type GenerateQuestionsResponse,
} from "@/generated/fastapi";

export async function generateQuestions(
  accessToken: string | null | undefined,
  request: GenerateQuestionsRequest,
): Promise<GenerateQuestionsResponse | null> {
  try {
    const response = await generateQuestionsApiService({
      client: browserFastApiClient,
      auth: requireFastApiAccessToken(accessToken),
      body: request,
    });

    if (response.status !== 200 || !response.data) {
      console.error("Failed to generate prompting questions");
      return null;
    }

    return response.data;
  } catch (error) {
    console.error("Error generating prompting questions:", error);
    return null;
  }
}
